import emoji from 'emoji-aware';
const split = emoji.split;
export const getCharCountAndZone = ({ text, limit, displayZone = 50, warningZone = 20, }) => {
    const textLength = split(text).length;
    const charactersLeft = limit - textLength;
    const isDisplayZone = displayZone >= charactersLeft;
    const isWarningZone = charactersLeft >= 0 && charactersLeft <= warningZone;
    const isErrorZone = charactersLeft < 0;
    const getZone = () => {
        if (isErrorZone)
            return 'error';
        if (isWarningZone)
            return 'warning';
        if (isDisplayZone)
            return 'display';
        return 'none';
    };
    return { charsLeft: charactersLeft, zone: getZone() };
};
//# sourceMappingURL=get-char-count-and-zone.js.map